import { render, staticRenderFns } from "./PromRuleList.vue?vue&type=template&id=1a18920a&scoped=true"
import script from "./PromRuleList.vue?vue&type=script&lang=js"
export * from "./PromRuleList.vue?vue&type=script&lang=js"
import style0 from "./PromRuleList.vue?vue&type=style&index=0&id=1a18920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18920a",
  null
  
)

export default component.exports